import styled from 'styled-components';
import {dFlex, dFlexBetween, dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';
import {mobileMedia} from '../../../../../../globalVariables/GlobalVariables';
import {getPrimitive, getSpacing, getToken} from '@tickchak/react-share/app';

export const formContainer = styled.div`
    border-radius: ${getSpacing('spaceMd')};
    background-color: ${getPrimitive('grays.gray100')};
    padding: ${getSpacing('spaceLg')};
    height: calc(100% - 40px);
    margin-inline: ${getSpacing('spaceXl')};
`;

export const footer = styled.div`
    inset-inline-start: 0px;
    width: 100%;
    height: 40px;
    ${dFlexBetween}
    padding: ${getSpacing('spaceXl')};
    border-top: 1px solid ${getPrimitive('grays.gray200')};
    ${mobileMedia}{
        padding: ${getSpacing('spaceSm')};
    }
`;

export const footerButtons = styled.div`
    ${dFlex}
    gap: ${getSpacing('spaceSm')};
`;

export const container = styled.div`
    padding-top: ${getSpacing('spaceLg')};
    ${dFlexColumn}
    height: calc(100% - 50px);
    gap: ${getSpacing('spaceXl')};
`;

export const header = styled.div`
    height: 50px;
    background-color: ${getToken('color.brand.main')};
    width: 100%;
`;